// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BenchmarkModal_select-dropdown__XSlD4 {
  z-index: 1500 !important;
}

.BenchmarkModal_modal-body__2ZZpl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.BenchmarkModal_filter-group__AZH3l {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.BenchmarkModal_filter-label__7VQn7 {
  font-size: 14px;
  font-weight: 600;
  color: var(--accent-color);
}

.BenchmarkModal_compare-btn__93kcY {
  align-self: center;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 28px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(30, 58, 95, 0.2);
}
.BenchmarkModal_compare-btn__93kcY:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(30, 58, 95, 0.3);
  filter: brightness(110%);
}
.BenchmarkModal_compare-btn__93kcY:active:not(:disabled) {
  transform: translateY(0);
}
.BenchmarkModal_compare-btn__93kcY:disabled {
  background: #e0e0e0;
  color: #a0a0a0;
  cursor: not-allowed;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BenchmarkModal/BenchmarkModal.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,4CAAA;AACF;AACE;EACE,2BAAA;EACA,4CAAA;EACA,wBAAA;AACJ;AAEE;EACE,wBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AADJ","sourcesContent":[".select-dropdown {\n  z-index: 1500 !important;\n}\n\n.modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--accent-color);\n}\n\n.compare-btn {\n  align-self: center;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 28px;\n  border-radius: 12px;\n  border: none;\n  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 4px 12px rgba(30, 58, 95, 0.2);\n\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(30, 58, 95, 0.3);\n    filter: brightness(110%);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    background: #e0e0e0;\n    color: #a0a0a0;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select-dropdown": `BenchmarkModal_select-dropdown__XSlD4`,
	"modal-body": `BenchmarkModal_modal-body__2ZZpl`,
	"filter-group": `BenchmarkModal_filter-group__AZH3l`,
	"filter-label": `BenchmarkModal_filter-label__7VQn7`,
	"compare-btn": `BenchmarkModal_compare-btn__93kcY`
};
export default ___CSS_LOADER_EXPORT___;
